<template>
  <div>
    <el-row>
      <el-col span="16" :offset=4>
        <span style="font-size: 16px; font-weight: bold;">{{name}} 设定参数</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col span="16" :offset=4>
        <el-select v-model="selectedVal" style="width: 265px" size="small" @change="statusChange">
          <el-option key="0" label="开启" value="0">
          </el-option>
          <el-option key="1" label="关闭" value="1">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="text-align: left;" span="16" :offset=4>
        <el-checkbox v-if="selectedVal === '0'" v-model="fadebrighter">渐亮模式</el-checkbox>
        <el-checkbox v-if="selectedVal === '1'" v-model="fade">渐灭模式</el-checkbox>
      </el-col>
    </el-row>
    <el-row v-if="readonly === 0">
      <el-col span="12" :offset=6>
        <el-button type="primary" class="attr-window-button" round @click="save()">
          保存
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: null
    },
    name: {
      type: String,
      default: ''
    },
    readonly: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      selectedVal: '1',
      operateType: 1,
      fadebrighter: false,
      fade: false,
      returnStr: {
        data: {
          operateType: ''
        },
        nameText: ''
      }
    }
  },
  computed: {
    getProperty: function() {
      return this.value
    }
  },
  watch: {
    getProperty: {
      handler: function(newValue) {
        this.init()
      },
      deep: true
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (this.value) {
        if (this.value.operateType === 0) {
          this.selectedVal = '0'
          this.fadebrighter = false
          this.operateType = this.value.operateType
        }
        else if (this.value.operateType === 1) {
          this.selectedVal = '1'
          this.fade = false
          this.operateType = this.value.operateType
        }
        else if (this.value.operateType === 2) {
          this.selectedVal = '0'
          this.fadebrighter = true
          this.operateType = 0
        }
        else if (this.value.operateType === 3) {
          this.selectedVal = '1'
          this.fade = true
          this.operateType = 1
        }
      }
      else {
        this.selectedVal = '1'
        this.operateType = 1
        this.fadebrighter = false
        this.fade = false
      }
    },
    statusChange(val) {
      if (val === '0') {
        this.operateType = 0
      }
      else {
        this.operateType = 1
      }
      this.fadebrighter = false
      this.fade = false
    },
    save() {
      if (this.operateType === 0) {
        if (this.fadebrighter) {
          this.returnStr.data.operateType = 2
          this.returnStr.nameText = this.name + ' 开 渐亮'
        }
        else {
          this.returnStr.data.operateType = 0
          this.returnStr.nameText = this.name + ' 开'
        }
      }
      else {
        if (this.fade) {
          this.returnStr.data.operateType = 3
          this.returnStr.nameText = this.name + ' 关 渐灭'
        }
        else {
          this.returnStr.data.operateType = 1
          this.returnStr.nameText = this.name + ' 关'
        }
      }
      console.log(JSON.stringify(this.returnStr))
      this.$emit('callBackJson', this.returnStr)
    }
  }
}
</script>

<style scoped>
.el-row {
  text-align: center;
}
.el-row:not(:first-child) {
  margin-top: 16px;
}
.el-row:last-child {
  margin-top: 20px;
}
/deep/ .el-radio{
  display: block;
  line-height: 30px;
  white-space: normal;
  margin-right: 0;
}
.attr-window-button {
  width: 96px;
  height: 40px;
  background-color: #4D78FF;
  border-color: rgb(77, 120, 255);
}
.attr-window-button:hover {
  background-color: #355cd8;
}
/deep/ .el-input__inner {
  /* background-color: #131B25; */
  /* color:white ; */
}
</style>
